var closeHandler = function closeHandler(component) {
  component.classList.remove('active-banner');
  setTimeout(function () {
    return component.style.display = 'none';
  }, 400);
};
var formPopUpFunction = function formPopUpFunction(component) {
  var _component$querySelec;
  setTimeout(function () {
    setTimeout(function () {
      return component.classList.add('active-banner');
    }, 200);
    component.style.display = 'flex';
  }, 6000);
  var closeElement = document.createElement('div');
  closeElement.classList.add('flex-banner__close');
  closeElement.innerText = 'x';
  (_component$querySelec = component.querySelector('.elements')) === null || _component$querySelec === void 0 || _component$querySelec.appendChild(closeElement);
  component.querySelector('.flex-banner__close').addEventListener('click', function (e) {
    closeHandler(component);
  });
};
export default formPopUpFunction;